"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _PresenceMoreCommentersAvatar = _interopRequireDefault(require("composer-lib/components/presence/PresenceMoreCommentersAvatar"));

var _PresencePopover = _interopRequireDefault(require("composer-lib/components/presence/PresencePopover"));

var _constants = require("composer-lib/lib/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _immutable = require("immutable");

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var MAX_AVATARS = 4;
var COMMENTER_TO_COMMENTER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_COMMENTER,
    COMMENTER_TO_IDLE_LOCKER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_IDLE_LOCKER,
    COMMENTER_TO_LOCKER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_LOCKER,
    LOCKER = _constants.PRESENCE_RELATIONSHIPS.LOCKER,
    REQUESTER_TO_LOCKER = _constants.PRESENCE_RELATIONSHIPS.REQUESTER_TO_LOCKER;

var langKey = function langKey(key) {
  return "composer-lib.header.PresenceAvatars." + key;
};

var _default = (0, _createReactClass.default)({
  displayName: "PresenceAvatars",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    dropdownPlacement: _propTypes.default.string,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    offset: _propTypes.default.bool,
    passLock: _propTypes.default.func.isRequired,
    presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
    refetchUsers: _propTypes.default.func.isRequired,
    rejectRequestLockFromUser: _propTypes.default.func.isRequired,
    requestLock: _propTypes.default.func.isRequired,
    requestLockFromUser: _propTypes.default.func.isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    tooltipPlacement: _propTypes.default.string,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  contextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  getInitialState: function getInitialState() {
    return {
      dropdownOpen: null,
      moreCommentersPopoverOpen: false
    };
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props = this.props,
        auth = _this$props.auth,
        presence = _this$props.presence;
    var locker = presence.locker;
    var userId = auth.user.get('userId');

    if (locker !== nextProps.presence.locker && (userId === locker || userId === nextProps.presence.locker)) {
      this.setState(this.getInitialState());
    }
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        presence = _this$props2.presence,
        refetchUsers = _this$props2.refetchUsers;
    var commenters = presence.commenters;
    var prevCommenters = prevProps.presence.commenters;

    if (commenters !== prevCommenters && !commenters.isSubset(prevCommenters)) {
      refetchUsers();
    }
  },
  toggleMoreCommentersPopoverOpen: function toggleMoreCommentersPopoverOpen() {
    var dropdownOpen = this.state.dropdownOpen;
    var moreCommentersPopoverOpen = !this.state.moreCommentersPopoverOpen;

    if (!moreCommentersPopoverOpen) {
      dropdownOpen = null;
    }

    this.setState({
      dropdownOpen: dropdownOpen,
      moreCommentersPopoverOpen: moreCommentersPopoverOpen
    });
  },
  getPossiblyUnlockedFromIdleness: function getPossiblyUnlockedFromIdleness() {
    var lockedUntil = this.props.lock.lockedUntil;

    var lockedPlus2Minutes = _I18n.default.moment(lockedUntil).add(2, 'minutes');

    var now = _I18n.default.moment();

    return now.isAfter(lockedPlus2Minutes);
  },
  getPrefix: function getPrefix(user) {
    var _this$props3 = this.props,
        auth = _this$props3.auth,
        lock = _this$props3.lock,
        presence = _this$props3.presence,
        saveState = _this$props3.saveState;
    var locker = presence.locker,
        requesters = presence.requesters;
    var id = user.id;
    var lockedComposition = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);

    if (lockedComposition) {
      if (id === locker) {
        if (this.getPossiblyUnlockedFromIdleness()) {
          return COMMENTER_TO_IDLE_LOCKER;
        }

        return COMMENTER_TO_LOCKER;
      }

      return COMMENTER_TO_COMMENTER;
    } else if (requesters.has(user.id)) {
      return REQUESTER_TO_LOCKER;
    }

    return LOCKER;
  },
  getToggleDropdownForUserId: function getToggleDropdownForUserId(id) {
    var dropdownOpen = null;

    if (this.state.dropdownOpen !== id) {
      dropdownOpen = id;
    }

    this.setState({
      dropdownOpen: dropdownOpen
    });
  },
  renderShortUserTitle: function renderShortUserTitle(user) {
    var firstName = user.firstName,
        lastName = user.lastName;
    var prefix = this.getPrefix(user);

    var closeStyle = _I18n.default.SafeString('</i>');

    var openStyle = _I18n.default.SafeString('<i>');

    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: langKey(prefix + ".shortUserTitle"),
      options: {
        closeStyle: closeStyle,
        firstName: firstName,
        lastName: lastName,
        openStyle: openStyle
      }
    });
  },
  renderMoreCommentersAvatar: function renderMoreCommentersAvatar(commenters) {
    return _react.default.createElement(_PresenceMoreCommentersAvatar.default, Object.assign({}, this.props, {
      commenters: commenters,
      dropdownOpen: this.state.dropdownOpen,
      getPopoverToggleOpen: this.getToggleDropdownForUserId,
      getPrefix: this.getPrefix,
      key: "more-commenters",
      open: this.state.moreCommentersPopoverOpen,
      renderShortUserTitle: this.renderShortUserTitle,
      toggleOpen: this.toggleMoreCommentersPopoverOpen
    }));
  },
  renderUser: function renderUser(user) {
    return _react.default.createElement(_PresencePopover.default, Object.assign({}, this.props, {
      key: user.id,
      open: user.id === this.state.dropdownOpen,
      prefix: this.getPrefix(user),
      shortUserTitle: this.renderShortUserTitle(user),
      toggleOpen: this.partial(this.getToggleDropdownForUserId, user.id),
      user: user
    }));
  },
  renderLocker: function renderLocker() {
    var _this$props4 = this.props,
        auth = _this$props4.auth,
        lock = _this$props4.lock,
        presence = _this$props4.presence,
        saveState = _this$props4.saveState;
    var locker = presence.locker;
    var lockedComposition = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);

    if (!locker || !lockedComposition) {
      return null;
    }

    var user = (0, _userHelpers.parseUser)(locker, this.props.users);
    return this.renderUser(user);
  },
  renderCommenters: function renderCommenters(locker) {
    var _this$props5 = this.props,
        presence = _this$props5.presence,
        users = _this$props5.users;
    var max = locker ? MAX_AVATARS - 1 : MAX_AVATARS;
    var commenters = presence.commenters.toSeq().map(function (id) {
      return (0, _userHelpers.parseUser)(id, users);
    });

    if (commenters.size <= max) {
      return commenters.map(this.renderUser);
    }

    return commenters.take(max - 1).map(this.renderUser).concat(this.renderMoreCommentersAvatar(commenters.slice(max - 1)));
  },
  render: function render() {
    var _this$props6 = this.props,
        composition = _this$props6.composition,
        offset = _this$props6.offset;

    if (composition.isReadOnly()) {
      return null;
    }

    var renderedLocker = this.renderLocker();
    var renderedCommenters = this.renderCommenters(renderedLocker);
    var className = (0, _classnames.default)('nav-item', 'presence-avatars', {
      offset: offset
    });

    if (!renderedLocker && renderedCommenters.size < 1) {
      // we give this div width no matter the contents and it breaks the header
      return null;
    }

    return _react.default.createElement("div", {
      className: className
    }, renderedLocker, renderedCommenters);
  }
});

exports.default = _default;
module.exports = exports.default;